export default {
    tableName: 'land',
    attributes: {
      unitprice: {
        type: 'number',
        required: true,
      },
      typeIva:{
        type:'string',
        required:true
      },
      quote: {
        model: 'quote',
      },
      material:{
        model: 'materials',
        required:true
      },
      iva:{
        type:'string',
        required:true,
      },
      total: {
        type: 'number',
        required: true,
      }
    },
}



// WEBPACK FOOTER //
// ./src/models/Land.js